/* ============ JOYRIDE HEMP CO. ============ */
(function () {
  'use strict';

  /* ---- Hero video: swap source by viewport ---- */
  var heroVideo = document.getElementById('heroVideo');
  var MOBILE_Q = '(max-width: 760px)';
  var mq = window.matchMedia(MOBILE_Q);

  // Sources come from data attributes when present (Shopify theme) with static-site fallbacks
  function heroAttr(name, fallback) {
    return (heroVideo && heroVideo.getAttribute(name)) || fallback;
  }
  var SOURCES = {
    desktop: { src: heroAttr('data-desktop-src', 'assets/hero.mp4'),        poster: heroAttr('data-desktop-poster', 'assets/hero-poster.jpg') },
    mobile:  { src: heroAttr('data-mobile-src',  'assets/hero-mobile.mp4'), poster: heroAttr('data-mobile-poster',  'assets/hero-poster-mobile.jpg') }
  };

  function applyHero(isMobile) {
    if (!heroVideo) return;
    var mode = isMobile ? 'mobile' : 'desktop';
    if (heroVideo.getAttribute('data-mode') === mode) return;
    heroVideo.setAttribute('data-mode', mode);
    var cfg = SOURCES[mode];
    heroVideo.setAttribute('poster', cfg.poster);
    heroVideo.setAttribute('src', cfg.src);
    heroVideo.load();
    var p = heroVideo.play();
    if (p && p.catch) p.catch(function () {/* autoplay may be blocked; poster shows */});
  }

  applyHero(mq.matches);
  // Safari <14 uses addListener
  if (mq.addEventListener) mq.addEventListener('change', function (e) { applyHero(e.matches); });
  else if (mq.addListener) mq.addListener(function (e) { applyHero(e.matches); });

  /* ---- Reveal header brand once scrolled past the hero video ---- */
  var header = document.querySelector('.header');
  var hero = document.getElementById('top');
  var bar = document.querySelector('.bar');
  if (header && hero) {
    var ticking = false;
    function updateHeader() {
      ticking = false;
      // Dock the header beneath the announcement bar, riding up as the bar scrolls away
      var barH = bar ? bar.offsetHeight : 0;
      header.style.top = Math.max(0, barH - window.scrollY) + 'px';
      // Reveal the solid header + logo: halfway past the video on mobile, near the end on desktop
      var trigger = mq.matches ? hero.offsetHeight * 0.5 : (hero.offsetHeight - header.offsetHeight);
      header.classList.toggle('is-scrolled', window.scrollY > trigger);
    }
    function onScroll() {
      if (!ticking) { ticking = true; window.requestAnimationFrame(updateHeader); }
    }
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', updateHeader);
    updateHeader();
  }

  /* ---- Mobile nav drawer ---- */
  var hamburger = document.getElementById('hamburger');
  var nav = document.getElementById('nav');
  if (hamburger && nav) {
    hamburger.addEventListener('click', function () {
      var open = nav.classList.toggle('is-open');
      hamburger.classList.toggle('is-open', open);
      hamburger.setAttribute('aria-expanded', open ? 'true' : 'false');
    });
    // Parent items never navigate — clicking one just toggles its submenu
    nav.addEventListener('click', function (e) {
      var parent = e.target.closest('.nav__link--parent');
      if (parent) {
        e.preventDefault();
        var item = parent.closest('.nav__item');
        var open = item.classList.toggle('is-open');
        parent.setAttribute('aria-expanded', open ? 'true' : 'false');
        return;
      }
      // Close drawer after tapping a link
      if (e.target.closest('.nav__link') || e.target.closest('.nav__drop-link')) {
        nav.classList.remove('is-open');
        hamburger.classList.remove('is-open');
        hamburger.setAttribute('aria-expanded', 'false');
      }
    });
    // Clicking anywhere else closes a click-pinned dropdown
    document.addEventListener('click', function (e) {
      if (e.target.closest('.nav__item')) return;
      var openItems = nav.querySelectorAll('.nav__item.is-open');
      for (var i = 0; i < openItems.length; i++) {
        openItems[i].classList.remove('is-open');
        var p = openItems[i].querySelector('.nav__link--parent');
        if (p) p.setAttribute('aria-expanded', 'false');
      }
    });
  }

  /* ---- Product page: keep the headline price on the selected variant ---- */
  var variantSelect = document.getElementById('pdp-variant');
  var pdpPrice = document.querySelector('[data-price]');
  if (variantSelect && pdpPrice) {
    variantSelect.addEventListener('change', function () {
      var opt = variantSelect.options[variantSelect.selectedIndex];
      if (opt && opt.getAttribute('data-price')) {
        pdpPrice.textContent = opt.getAttribute('data-price');
      }
    });
  }

  /* ---- Add to cart (Shopify AJAX API) ---- */
  var cartCount = document.getElementById('cartCount');

  function setCartCount(n) {
    if (!cartCount) return;
    cartCount.textContent = String(n);
    cartCount.hidden = n === 0;
  }

  function flashButton(btn, text) {
    var label = btn.textContent;
    btn.classList.add('added');
    btn.textContent = text;
    setTimeout(function () { btn.textContent = label; btn.classList.remove('added'); }, 1100);
  }

  document.addEventListener('submit', function (e) {
    var form = e.target.closest('form[action*="/cart/add"]');
    if (!form) return;
    var btn = form.querySelector('[data-add]');
    if (!btn) return; // let full-page product forms submit normally

    e.preventDefault();
    btn.disabled = true;

    fetch(window.Shopify && window.Shopify.routes ? window.Shopify.routes.root + 'cart/add.js' : '/cart/add.js', {
      method: 'POST',
      headers: { 'Accept': 'application/json' },
      body: new FormData(form)
    })
      .then(function (res) {
        if (!res.ok) throw new Error('add failed');
        return fetch('/cart.js', { headers: { 'Accept': 'application/json' } });
      })
      .then(function (res) { return res.json(); })
      .then(function (cart) {
        setCartCount(cart.item_count);
        flashButton(btn, 'Added ✓');
      })
      .catch(function () {
        flashButton(btn, 'Try again');
      })
      .finally(function () { btn.disabled = false; });
  });
})();
